import * as React from "react";
import type { SVGProps } from "react";
const SvgNotsyncedStripeIdle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18" {...props}
  >
    <path
      fill="#E7E7E7"
      d="M0 4a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M8.304 6.978c0-.429.345-.593.916-.593.819 0 1.853.252 2.672.703V4.505A7 7 0 0 0 9.22 4C7.033 4 5.578 5.165 5.578 7.11c0 3.033 4.095 2.55 4.095 3.857 0 .505-.431.67-1.035.67-.894 0-2.036-.373-2.941-.879v2.616A7.3 7.3 0 0 0 8.638 14c2.241 0 3.782-1.132 3.782-3.099-.01-3.275-4.116-2.692-4.116-3.923"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNotsyncedStripeIdle;
